const GetObjectives = async (gantt, thiss, type) => {
  let params;
  thiss.getStadistict();
  if (thiss.currentUser.PositionID == 16) {
    params = {
      CompanyID: thiss.currentCompany,
      DirecctionID: thiss.directionId,
      DepartmentID: null,
      ResponsableID: thiss.employeeId,
      PerpectiveID: thiss.PerpectiveId,
      TypeStrategic: thiss.Strategic,
      // rolPermi: thiss.confirmRoles(),
      Byme: thiss.creadoPorMi,
      CreateByID: thiss.creadoPorMi ? thiss.currentUser.EmployeeId : 0,
      StatusTask: thiss.statusSelect,
      allTask: type == 1 ? true : false,
      taskOnLate: type == 2 ? true : false,
      taskOnCurrentWeek: type == 3 ? true : false,
      taskOnNextWeek: type == 4 ? true : false,
      taskOnMonth: type == 5 ? true : false,
      taskOnNextMonth: type == 6 ? true : false,
      Year: thiss.year,
      Month: thiss.month,
      FourMonthPeriod: thiss.fourMonthPeriodType
    };
  } else {
    params = {
      CompanyID: thiss.currentCompany,
      Byme: thiss.creadoPorMi,
      CreateByID: thiss.creadoPorMi ? thiss.currentUser.EmployeeId : 0,
      DirecctionID: null,
      DepartmentID: null,
      ResponsableID: thiss.confirmRoles()
        ? thiss.employeeId == 0
          ? thiss.currentUser.EmployeeId
          : thiss.employeeId
        : thiss.currentUser.EmployeeId,
      PerpectiveID: thiss.PerpectiveId,
      TypeStrategic: thiss.Strategic,
      // rolPermi: thiss.confirmRoles(),
      StatusTask: thiss.statusSelect,
      allTask: type == 1 ? true : false,
      taskOnLate: type == 2 ? true : false,
      taskOnCurrentWeek: type == 3 ? true : false,
      taskOnNextWeek: type == 4 ? true : false,
      taskOnMonth: type == 5 ? true : false,
      taskOnNextMonth: type == 6 ? true : false,
      Year: thiss.year,
      Month: thiss.month,
      FourMonthPeriod: thiss.fourMonthPeriodType
    };
  }

  await thiss.$http
    .get(`/api/CMI/Objetives/ReportGanttObjetiveByCompany`, {
      params: params
    })
    .then((resp) => {
      // let index = 0;
      // index = thiss.PerpectiveId == 0 ? 0 : thiss.PerpectiveId - 1;
      //para mostrar todos los objectivos
      // thiss.totalTask = element.Tasks.length;
      //if (thiss.PerpectiveId != null) {
      thiss.tasks.totalTask = 0;
      for (const element of resp.data) {
        const totalTask = thiss.statusSelect != 3 ? element.TotalTask : 0;
        const totalSubTask = thiss.statusSelect != 3 ? element.TotalSubTask : 0;

        const totalTaskCompleted =
          thiss.statusSelect == 3 ? element.TotalTaskCompleted : 0;
        const totalSubTaskCompleted =
          thiss.statusSelect == 3 ? element.TotalSubTaskCompleted : 0;

        thiss.tasks.totalTask +=
          totalTask + totalTaskCompleted + totalSubTask + totalSubTaskCompleted;
        break;
      }

      let objetivesIds = [];

      resp.data.forEach((element) => {
        element;

        element.Objetives.forEach((ob) => {
          let congDateEnd = ob.DateEnd.slice(0, ob.DateEnd.length - 9);
          let congDateInit = ob.DateInit.slice(0, ob.DateInit.length - 9);
          let Duration =
            Math.abs(new Date(congDateEnd) - new Date(congDateInit)) /
            (1000 * 3600 * 24);

          //PUSH OBJECTIVES

          if (thiss.statusSelect == 4) {
            if (ob.Percentage == 100) {
              objetivesIds.push(ob.CombinedId);
              thiss.tasks.data.push({
                // id: ob.ID,
                id: ob.CombinedId,
                text: ob.Description,
                owner_id: ob.ResposibleID,
                start_date: congDateInit,
                end_date: congDateEnd,
                duration: Duration,
                progress: ob.Percentage,
                details: ob.Details,
                owner_name: ob.Responsable,
                image_owner: ob.UserUrlImage,
                image_created: ob.OwnerUrlImage,
                type: ob.PerpectiveId,
                created_by: ob.Owner,
                created_name: ob.OwnerName,
                percentage: ob.Percentage,
                type_strategic: ob.TypeStrategic,
                read: ob.Read,
                new: false,
                approved: ob.Approved
                // created: ob.Owner
              });
            }
          } else {
            thiss.tasks.data.push({
              // id: ob.ID,
              id: ob.CombinedId,
              text: ob.Description,
              owner_id: ob.ResposibleID,
              start_date: congDateInit,
              end_date: congDateEnd,
              duration: Duration,
              progress: ob.Percentage,
              details: ob.Details,
              owner_name: ob.Responsable,
              image_owner: ob.UserUrlImage,
              image_created: ob.OwnerUrlImage,
              type: ob.PerpectiveId,
              created_by: ob.Owner,
              created_name: ob.OwnerName,
              percentage: ob.Percentage,
              type_strategic: ob.TypeStrategic,
              read: ob.Read,
              new: false,
              approved: ob.Approved

              // created: ob.Owner
            });
          }
        });

        if (thiss.statusSelect == 4) thiss.tasks.totalTask = 0;

        element.Tasks.forEach((task) => {
          let congDateEnd = task.LimitDate.slice(0, task.LimitDate.length - 9);
          let congDateInit = task.InitialDate.slice(
            0,
            task.InitialDate.length - 9
          );
          let Duration =
            Math.abs(new Date(congDateEnd) - new Date(congDateInit)) /
            (1000 * 3600 * 24);

          if (
            thiss.responsableSelect == 1 &&
            task.ResponsableId != thiss.currentUser.EmployeeId
          ) {
            return;
          }

          if (
            thiss.responsableSelect == 2 &&
            task.ResponsableId == thiss.currentUser.EmployeeId
          ) {
            return;
          }

          //PUSH TASK

          if (thiss.statusSelect == 4) {
            if (objetivesIds.includes(task.DisplayObjet)) {
              thiss.tasks.totalTask++;
              thiss.tasks.data.push({
                // id: task.ID + "task",
                id: task.CombinedId,
                text: task.Description,
                owner_id: task.ResponsableId,
                start_date: congDateInit,
                end_date: congDateEnd,
                duration: Duration,
                progress: task.PercentageProsposal,
                details: task.Details,
                parent: task.ObjectiveCombinedId,
                owner_name: task.Responsable,
                image_owner: task.UserUrlImage,
                image_created: task.OwnerUrlImage,
                type: task.PerpectiveId,
                created_by: task.CreatedBy,
                created_name: task.OwnerName,
                percentage: task.Percentage,
                read: task.Read,
                new: false,
                evidence:
                  task.Evidence != null
                    ? `<a href="${task.Evidence}" target="_blank">Ver Evidencia</a>`
                    : "",
                approved: task.Approved,
                type_strategic: task.TypeStrategic

                // created: task.CreatedBy
              });
            }
          } else {
            thiss.tasks.data.push({
              // id: task.ID + "task",
              id: task.CombinedId,
              text: task.Description,
              owner_id: task.ResponsableId,
              start_date: congDateInit,
              end_date: congDateEnd,
              duration: Duration,
              progress: task.PercentageProsposal,
              details: task.Details,
              parent: task.ObjectiveCombinedId,
              owner_name: task.Responsable,
              image_owner: task.UserUrlImage,
              image_created: task.OwnerUrlImage,
              type: task.PerpectiveId,
              created_by: task.CreatedBy,
              created_name: task.OwnerName,
              percentage: task.Percentage,
              read: task.Read,
              new: false,
              evidence:
                task.Evidence != null
                  ? `<a href="${task.Evidence}" target="_blank">Ver Evidencia</a>`
                  : "",
              approved: task.Approved,
              type_strategic: task.TypeStrategic

              // created: task.CreatedBy
            });
          }
        });

        //SubTasks
        element.SubTasks.forEach((subtask) => {
          let congDateEnd = subtask.LimitDate.slice(
            0,
            subtask.LimitDate.length - 9
          );
          let congDateInit = subtask.InitialDate.slice(
            0,
            subtask.InitialDate.length - 9
          );
          let Duration =
            Math.abs(new Date(congDateEnd) - new Date(congDateInit)) /
            (1000 * 3600 * 24);

          if (
            thiss.responsableSelect == 1 &&
            subtask.ResponsableId != thiss.currentUser.EmployeeId
          ) {
            return;
          }

          if (
            thiss.responsableSelect == 2 &&
            subtask.ResponsableId == thiss.currentUser.EmployeeId
          ) {
            return;
          }

          //PUSH TASK
          thiss.tasks.data.push({
            // id: subtask.ID + "task",
            id: subtask.CombinedId,
            text: subtask.Description,
            owner_id: subtask.ResponsableId,
            start_date: congDateInit,
            end_date: congDateEnd,
            duration: Duration,
            progress: subtask.PercentageProsposal,
            details: subtask.Details,
            parent: subtask.TaskCombinedId,
            owner_name: subtask.Responsable,
            image_owner: subtask.UserUrlImage,
            image_created: subtask.OwnerUrlImage,
            type: subtask.PerpectiveId,
            created_by: subtask.CreatedBy,
            created_name: subtask.OwnerName,
            percentage: subtask.Percentage,
            read: subtask.Read,
            new: false,
            evidence:
              subtask.Evidence != null
                ? `<a href="${subtask.Evidence}" target="_blank">Ver Evidencia</a>`
                : "",
            approved: subtask.Approved,
            type_strategic: subtask.TypeStrategic

            // created: task.CreatedBy
          });
        });
      });
      thiss.Setlightbox();
      gantt.parse(thiss.tasks);

      //  return;
      // }
      // else {

      //para mostrar los obejctivos por pesperctiva
      // resp.data.filter((d) => d.Perpective.Id == thiss.PerpectiveId)[0].Objetives.forEach((element) => {
      //   let congDateEnd = element.DateEnd.slice(0, element.DateEnd.length - 9);
      //   let congDateInit = element.DateInit.slice(
      //     0,
      //     element.DateInit.length - 9
      //   );
      //   let Duration =
      //     Math.abs(new Date(congDateEnd) - new Date(congDateInit)) /
      //     (1000 * 3600 * 24);
      //   //PUSH OBJECTIVES
      //   thiss.tasks.data.push({
      //     // id: element.ID,
      //     id: element.CombinedId,
      //     text: element.Description,
      //     owner_id: element.ResposibleID,
      //     start_date: congDateInit,
      //     end_date: congDateEnd,
      //     duration: Duration,
      //     progress: element.Percentage,
      //     details: element.Details,
      //     owner_name: element.Responsable,
      //     image_owner: element.UserUrlImage,
      //     image_created: element.OwnerUrlImage,
      //     type: element.PerpectiveId,
      //     created_by: element.Owner,
      //     created_name: element.OwnerName,
      //     type_strategic: element.TypeStrategic,
      //     Percentage: element.Percentage,
      //     read: element.Read,
      //     new: false,
      //     approved: element.Approved

      //     // created: element.Owner
      //   });
      // });

      // //para mostrar los tareas por pesperctiva
      // resp.data.filter((d) => d.Perpective.Id == thiss.PerpectiveId)[0].Tasks.forEach((task) => {
      //   //get taskGantt
      //   let congDateEnd = task.LimitDate.slice(0, task.LimitDate.length - 9);
      //   let congDateInit = task.InitialDate.slice(
      //     0,
      //     task.InitialDate.length - 9
      //   );
      //   let Duration =
      //     Math.abs(new Date(congDateEnd) - new Date(congDateInit)) /
      //     (1000 * 3600 * 24);
      //   //PUSH TASK
      //   thiss.tasks.data.push({
      //     // id: task.ID + "task",
      //     id: task.CombinedId,
      //     text: task.Description,
      //     owner_id: task.ResponsableId,
      //     start_date: congDateInit,
      //     end_date: congDateEnd,
      //     duration: Duration,
      //     progress: task.PercentageProsposal,
      //     details: task.Details,
      //     parent: task.ObjectiveCombinedId,
      //     owner_name: task.Responsable,
      //     image_owner: task.UserUrlImage,
      //     image_created: task.OwnerUrlImage,
      //     type: task.PerpectiveId,
      //     created_by: task.CreatedBy,
      //     created_name: task.OwnerName,
      //     Percentage: task.Percentage,
      //     evidence:
      //       task.Evidence != null
      //         ? `<a href="${task.Evidence}" target="_blank">Ver Evidencia</a>`
      //         : "",
      //     approved: task.Approved,
      //     read: task.Read,
      //     new: false
      //     // created: task.CreatedBy
      //   });
      // });

      // //para mostrar los subtareas por pesperctiva
      // resp.data.filter((d) => d.Perpective.Id == thiss.PerpectiveId)[0].SubTasks.forEach((subtask) => {
      //   //get taskGantt
      //   let congDateEnd = subtask.LimitDate.slice(
      //     0,
      //     subtask.LimitDate.length - 9
      //   );
      //   let congDateInit = subtask.InitialDate.slice(
      //     0,
      //     subtask.InitialDate.length - 9
      //   );
      //   let Duration =
      //     Math.abs(new Date(congDateEnd) - new Date(congDateInit)) /
      //     (1000 * 3600 * 24);
      //   //PUSH TASK
      //   thiss.subtasks.data.push({
      //     // id: subtask.ID + "subtask",
      //     id: subtask.CombinedId,
      //     text: subtask.Description,
      //     owner_id: subtask.ResponsableId,
      //     start_date: congDateInit,
      //     end_date: congDateEnd,
      //     duration: Duration,
      //     progress: subtask.PercentageProsposal,
      //     details: subtask.Details,
      //     parent: subtask.TaskCombinedId,
      //     owner_name: subtask.Responsable,
      //     image_owner: subtask.UserUrlImage,
      //     image_created: subtask.OwnerUrlImage,
      //     type: subtask.PerpectiveId,
      //     created_by: subtask.CreatedBy,
      //     created_name: subtask.OwnerName,
      //     Percentage: subtask.Percentage,
      //     evidence:
      //       subtask.Evidence != null
      //         ? `<a href="${subtask.Evidence}" target="_blank">Ver Evidencia</a>`
      //         : "",
      //     approved: subtask.Approved,
      //     read: subtask.Read,
      //     new: false
      //     // created: subtask.CreatedBy
      //   });
      // });
      //}

      // thiss.Setlightbox();
      // gantt.parse(thiss.tasks);
    })
    .catch((err) => {
      thiss.$message({
        type: "error",
        message: err.message
      });
    })
    .finally(() => {
      thiss.loading = false;
      thiss.collapseAll();
      gantt.open(thiss.OpenObjeID);
    });
};

export default GetObjectives;
